import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

import nlen from "../assets/Nlen.svg";
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import user from "../assets/user.png";
import phonee from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";

const Footer = () => {

  const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");

  useEffect(() => {
    fetch("https://api.app.mawalog.com/v1.2/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22);
    }
  }, [data]);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(""); // text from API
  const [userCaptcha, setUserCaptcha] = useState("");

  /* ------------------------------------------------------------------- API fetch */
  const fetchCaptcha = async () => {
    try {
      const res = await fetch("https://api.app.mawalog.com/v1.2/website");
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };

  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);

  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!data) return;
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random();
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }

    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = data.toString().split("");

    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 0.8;
      const x = 8 + i * 14 + (Math.random() * 4 - 2);
      const y = 22 + (Math.random() * 6 - 3);

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [data]);

  const [name, setName] = useState("");

  const [phone, setPhone] = useState("");

  // Fetch session ID and token
  useEffect(() => {
    fetch("http://localhost/maw-lumen/sonar-qube/admin_api/book_demo")
      .then((response) => response.json())
      .then((json) => {
        setSessionid(json.data.session_idd);
        setToken(json.data.token);
      })
      .catch((error) =>
        console.error("Error fetching token/sessionid:", error)
      );
  }, []);

  // Fetch captcha value
  const fetchCaptchaa = async () => {
    try {
      const res = await fetch(
        "http://localhost/maw-lumen/sonar-qube/admin_api/book_demo"
      );
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR");
      setSessionid(json.data.session_id);
      setToken(json.data.token);
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };

  useEffect(() => {
    fetchCaptcha();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email || !phone) {
      setFormError("Please fill all fields.");
      setFormSuccess("");
      return;
    }

    setFormError("");

    try {
      const captchaRes = await fetch(
        "http://localhost/maw-lumen/sonar-qube/admin_api/book_demo"
      );
      const captchaJson = await captchaRes.json();

      const response = await fetch(
        "http://localhost/maw-lumen/sonar-qube/admin_api/book_demo",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": token,
          },
          body: JSON.stringify({
            session_id: captchaJson.data.session_id,
            captcha: captchaJson.data.captcha_code,
            name,
            email,
            phone,
          }),
        }
      );

      const result = await response.json();

      if (response.ok && (result.success || result.status)) {
        setFormSuccess("Message sent successfully!");
        setFormError("");
        setName("");
        setEmail("");
        setPhone("");
        fetchCaptcha();
      } else {
        setFormError(result.message || "Validation error.");
        setFormSuccess("");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setFormError("Something went wrong. Try again.");
      setFormSuccess("");
    }
  };

  // Newsletter captcha refs/state (separate)
  const [submail, setSubmail] = useState("");
  const newsletterCanvasRef = useRef(null);
  const [newsCaptcha, setNewsCaptcha] = useState("");
  const [newsletterCaptcha, setNewsletterCaptcha] = useState({
    code: "",
    sessionId: "",
    token: "",
  });
  const [newsletterUserCaptcha, setNewsletterUserCaptcha] = useState(""); // <-- new state for newsletter captcha input
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const handleReload = () => {
    fetchNewsletterCaptcha();
  };

  const fetchNewsletterCaptcha = async () => {
    try {
      const response = await fetch("https://api.app.mawalog.com/v1.2/website");
      const json = await response.json();
      if (json?.data) {
        setNewsletterCaptcha({
          code: json.data.captcha_code,
          sessionId: json.data.session_id,
          token: json.data.token,
        });
      }
    } catch (err) {
      console.error("Error fetching newsletter captcha:", err);
    }
  };

  useEffect(() => {
    // fetch both captchas on mount so both canvases are ready
    fetchNewsletterCaptcha();
  }, []);

  // Draw newsletter captcha whenever it changes
  useEffect(() => {
    if (!newsletterCaptcha?.code) return;
    const canvas = newsletterCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    // noise / curves
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.lineWidth = 1 + Math.random();
      ctx.stroke();
    }

    // draw characters
    const chars = newsletterCaptcha.code.toString().split("");
    ctx.fillStyle = "#0A3A72";
    const fonts = [
      "Arial",
      "Verdana",
      "Georgia",
      "Courier New",
      "Times New Roman",
    ];
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 1.2;
      const x = 8 + i * 12 + (Math.random() * 4 - 2);
      const y = 24 + (Math.random() * 6 - 3);
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.font = `bold ${16 + Math.floor(Math.random() * 6)}px ${fonts[Math.floor(Math.random() * fonts.length)]
        }`;
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    // dots
    for (let i = 0; i < 35; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [newsletterCaptcha]);
  const handleSubscribe = async (e) => {
    e?.preventDefault?.();

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!submail) {
      toast("Please enter an email address");
      return;
    }

    if (!emailRegex.test(submail)) {
      toast("Please enter a valid email address");
      return;
    }

    if (!newsletterUserCaptcha) {
      toast("Please enter the captcha");
      return;
    }

    try {
      const res = await fetch("https://api.app.mawalog.com/v1.2/newsletter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-TOKEN": newsletterCaptcha.token || "", // use newsletter token
        },
        body: JSON.stringify({
          session_id: newsletterCaptcha.sessionId || "", // use newsletter session id
          captcha: newsletterUserCaptcha, // use newsletter captcha input
          email: submail,
          type: "Mawalog",
        }),
      });

      const result = await res.json();

      // On success clear inputs and reload captcha
      if (res.ok) {
        setSubmail("");
        setNewsletterUserCaptcha("");
        fetchNewsletterCaptcha();
      }

      toast(result.message || "Subscription response received");
    } catch (err) {
      console.error("Newsletter subscribe error:", err);
      toast("Subscription failed. Please try again.");
    }
  };

  return (
    <div className="bg-[#131519] text-white">
      {/* Footer Section */}
      <footer className="px-4 sm:px-6 lg:px-12 py-4 sm:py-6 lg:py-12">
        {/* Newsletter Section */}
        <div className="w-full sm:px-2 lg:px-4 sm:py-2 lg:py-4 flex flex-col gap-4 md:gap-8 lg:gap-12">
          {/* Top newsletter */}
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
            {/* Left Side */}
            <div className="flex items-start md:items-center gap-4 md:gap-6">
              <img
                src={news}
                alt="newsletter"
                className="w-12 h-12 md:w-[80px] md:h-[80px]"
              />
              <h2 className="text-xl md:text-[28px] font-bold leading-tight">
                Join our newsletter to <br className="hidden md:block" />
                keep up to date with us!
              </h2>
            </div>

            <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
              {/* Newsletter input */}
              <div
                className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
                style={{ borderRadius: "6px" }}
              >
                <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
                <input
                  type="email"
                  value={submail}
                  onChange={(e) => setSubmail(e.target.value)}
                  placeholder="Enter your email"
                  className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
                />
              </div>

              {/* Captcha line (canvas + refresh + input + subscribe button) */}
              {/* Outer wrapper to center the row */}
              <div className="w-full flex justify-center">
                <div className="flex items-center gap-3">
                  {/* Captcha canvas */}
                  <div className="captcha-box">
                    <canvas
                      ref={newsletterCanvasRef}
                      id="newsletterCaptchaCanvas"
                      width={60}
                      height={40}
                      style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
                    />
                  </div>

                  {/* Refresh button */}
                  <button
                    onClick={handleReload}
                    style={{
                      background: "#07862B ",
                      color: "#fff",
                      border: "none",
                      padding: "6px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="23 4 23 10 17 10"></polyline>
                      <polyline points="1 20 1 14 7 14"></polyline>
                      <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                    </svg>
                  </button>

                  {/* Captcha input */}
                  <input
                    type="text"
                    placeholder="Enter captcha"
                    value={newsletterUserCaptcha}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      if (value.length <= 3) {
                        setNewsletterUserCaptcha(value);
                      }
                    }}
                    className="captcha-input"
                  />


                  {/* Subscribe button */}
                  <button
                    className="subscribe-button"
                    onClick={handleSubscribe}
                  >
                    Subscribe
                  </button>
                </div>
              </div>

              <style>{`
      .captcha-box {
        width: 60px !important;
        height: 35px !important;
        border-radius: 6px !important;
        overflow: hidden !important;
        color: 131519;
        background-color: #fff !important;
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }
     
      .captcha-input {
        padding: 11px 8px !important;
        border-radius: 6px !important;
        border: 1px solid #ccc !important;
        outline: none !important;
        width: 100px !important;
        background: #131519 !important;
        color: #fff !important;
        font-size: 10px !important;
      }
     
      .subscribe-button {
        padding: 10px 16px !important;
        border-radius: 8px !important;
        border: none !important;
        background: #07862B !important;
        color: #fff !important;
        font-weight: bold !important;
        font-size: 13px !important;
        cursor: pointer !important;
        white-space: nowrap !important;
      }
     
      @media(max-width:480px){
        .captcha-input { width: 70px !important; font-size: 12px !important; }
        .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
      }
    `}</style>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-gray-700 w-full" />

          {/* Main Footer Content */}
          <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
            {/* Company Info */}
            <div className="w-full lg:w-[30%]">
              <a href="/" aria-label="Lentera Home">
                <img src={nlen} alt="Lentera logo" className="mb-6" />
              </a>
              <p className="text-[#d4d4d4] leading-relaxed">
                We are highly experienced in offering software development,
                mobile application development, software consulting and project
                management delivery.
              </p>
              {/* Social Icons */}
              <div className="flex gap-4 mt-6 flex-wrap">
                <a
                  href="https://www.instagram.com/lenteratechnologies/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={inst} alt="Instagram" className="w-8 h-8" />
                </a>
                <a
                  href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={face} alt="Facebook" className="w-8 h-8" />
                </a>
                <a
                  href="https://www.youtube.com/@lenteratechnologies"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={you} alt="YouTube" className="w-8 h-8" />
                </a>
                <a
                  href="https://in.linkedin.com/company/lenteratechnologies"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={lin} alt="LinkedIn" className="w-8 h-8" />
                </a>
                <a
                  href="https://x.com/lenteratech"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={twi} alt="X" className="w-8 h-8" />
                </a>
              </div>
            </div>

            {/* Services */}
            <div className="w-full sm:w-[45%] md:w-auto">
              <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">
                OUR SERVICES
              </h4>
              <ul className="space-y-2 text-[#d4d4d4]">
                <li>
                  <Link to="/services/ai-services/" className="hover:text-white">
                    AI services
                  </Link>
                </li>
                <li>
                  <Link to="/services/web-development/" className="hover:text-white">
                    Web development
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services/mobile-app-development/"
                    className="hover:text-white"
                  >
                    Mobile app development
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services/software-consulting/"
                    className="hover:text-white"
                  >
                    Software consulting
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services/custom-development/"
                    className="hover:text-white"
                  >
                    Custom consulting
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services/third-party-integration/"
                    className="hover:text-white"
                  >
                    Third party integration
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services/enterprise-application/"
                    className="hover:text-white"
                  >
                    Enterprise Application
                  </Link>
                </li>
              </ul>
            </div>

            {/* Insights */}
            <div className="w-full sm:w-[45%] md:w-auto">
              <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">
                INSIGHTS
              </h4>
              <ul className="space-y-2 text-[#d4d4d4]">
                <li>
                  <Link to="/blogs" className="hover:text-white">
                    Blog
                  </Link>
                </li>
                <li>
                  <a
                    href="https://www.lentera.in/careers/"
                    className="hover:text-white"
                  >
                    Careers
                  </a>
                </li>
                <li>
                  <Link to="/blogs" className="hover:text-white">
                    News
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div className="w-full md:w-auto">
              <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">
                CONTACT US
              </h4>
              <div className="flex items-start gap-3 mb-3">
                <img src={phonee} alt="phone" className="w-9 h-9 mt-1" />
                <div>
                  <p className="text-[#999] text-sm">Phone number</p>
                  <a
                    href="tel:+914448563345"
                    className="text-white font-medium text-sm hover:underline"
                  >
                    +91-44-4856-3345
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3 mb-3">
                <img src={mail} alt="email" className="w-9 h-9 mt-1" />
                <div>
                  <p className="text-[#999] text-sm">Email address</p>
                  <a
                    href="mailto:info@lenteratech.com"
                    className="text-white font-medium text-sm hover:underline"
                  >
                    info@lenteratech.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <img src={loc} alt="location" className="w-9 h-9 mt-1" />
                <div>
                  <p className="text-[#999] text-sm">Location</p>
                  <a
                    href="https://www.google.com/maps?q=G1,+Plot+No+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white font-medium text-sm hover:underline block"
                  >
                    G1, Plot No, 824 and 826, 3rd
                    <br />
                    Main Rd, Ram Nagar South,
                    <br />
                    Madipakkam, Chennai,
                    <br />
                    Tamil Nadu 600091
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Bottom Section */}
      <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
        <p>© 2025 Lentera Technologies Pvt Ltd. All rights reserved.</p>
        <div className="flex flex-wrap gap-4 justify-center md:justify-end">
          <a href="/terms-condition/" className="hover:underline">
            Terms and conditions
          </a>
          <a href="/privacy-policy/" className="hover:underline">
            Privacy Policy
          </a>
          <a href="/cookie-policy/" className="hover:underline">
            Cookies Policy
          </a>
          <a href="/copyright-information/" className="hover:underline">
            Copyright information
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
